import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourApplication from "./sections/StartYourApplication";
import VisitOurOffice from "./sections/VisitOurOffice";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourApplication />
      <VisitOurOffice />
      <Footer />
    </div>;
}